import { Injectable } from '@angular/core';
import { Router, UrlSegment } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class RegionUrlService {
  constructor(private router: Router) {}

  private isCode(seg?: string): boolean {
    return !!seg && /^[a-z]{2}$/.test(seg.toLowerCase());
  }

  private fallbackCode(): string {
    try {
      const saved = (typeof localStorage !== 'undefined'
        ? localStorage.getItem('regionCode')
        : '') || '';
      const code = saved.toLowerCase();
      return this.isCode(code) ? code : 'ae';
    } catch {
      return 'ae';
    }
  }

  getCurrentCode(): string | null {
    const tree = this.router.parseUrl(this.router.url);
    const segs = tree.root.children['primary']?.segments ?? [];
    const first = segs[0]?.path?.toLowerCase();
    return this.isCode(first) ? first : null;
  }

  private normalizeParts(parts: any[]): any[] {
    return (parts || [])
      .flatMap(p => {
        if (typeof p !== 'string') return [p];
        return p
          .split('/')
          .map(s => s.trim())
          .filter(Boolean);
      })
      .filter(p => p !== null && p !== undefined && p !== '');
  }

  link(parts: any[] = []): any[] {
    const code = (this.getCurrentCode() ?? this.fallbackCode()).toLowerCase();

    const clean = this.normalizeParts(parts);

    if (clean.length && typeof clean[0] === 'string' && this.isCode(clean[0])) {
      clean.shift();
    }

    return ['/', code, ...clean];
  }

  navigateWithCode(code: string) {
    const tree = this.router.parseUrl(this.router.url);
    const segs: UrlSegment[] = tree.root.children['primary']?.segments ?? [];
    const rest = segs.slice(this.isCode(segs[0]?.path) ? 1 : 0).map(s => s.path);

    return this.router.navigate(['/', (code || this.fallbackCode()).toLowerCase(), ...rest], {
      queryParamsHandling: 'preserve',
      replaceUrl: true
    });
  }

  ensurePrefixed(defaultCode: string = 'ae'): void {
    const tree = this.router.parseUrl(this.router.url);
    const segs: UrlSegment[] = tree.root.children['primary']?.segments ?? [];
    const paths = segs.map(s => s.path);
    const p0 = paths[0]?.toLowerCase();
    const p1 = paths[1]?.toLowerCase();

    if (this.isCode(p0) && this.isCode(p1)) {
      const rest = paths.slice(2);
      this.router.navigate(['/', p0, ...rest], {
        queryParamsHandling: 'preserve',
        replaceUrl: true
      });
      return;
    }

    if (!this.isCode(p0)) {
      const code = (defaultCode || this.fallbackCode()).toLowerCase();
      this.router.navigate(['/', code, ...paths], {
        queryParamsHandling: 'preserve',
        replaceUrl: true
      });
    }
  }
}
